import { createClient } from '@supabase/supabase-js';

function requireEnvVar(key: 'VITE_SUPABASE_URL' | 'VITE_SUPABASE_ANON_KEY'): string {
  const value = import.meta.env[key];
  if (!value || typeof value !== 'string') {
    throw new Error(`[supabaseClient] Missing required environment variable: ${key}`);
  }
  return value;
}

function normalizeSupabaseUrl(rawUrl: string): string {
  let url = rawUrl.trim().replace(/\/+$/, '');

  // Guardrail: Supabase project URLs use the .supabase.co domain.
  if (url.includes('.supabase.com')) {
    url = url.replace('.supabase.com', '.supabase.co');
    console.warn('[supabaseClient] Normalized Supabase URL domain from .com to .co');
  }

  return url;
}

export const SUPABASE_URL = normalizeSupabaseUrl(requireEnvVar('VITE_SUPABASE_URL'));
export const SUPABASE_ANON_KEY = requireEnvVar('VITE_SUPABASE_ANON_KEY');

export const supabase = createClient(
  SUPABASE_URL,
  SUPABASE_ANON_KEY
);
